import { Command } from '@/app/common/base/command'

export class SubmitBnpChoiceCommand extends Command {

    public async run(productActionId: string, accepted: boolean) {
        await this.client.post(`/api/products/bankguarantees/actions/${productActionId}/submit-choice`, { accepted })
    }

}
